import { ChildListTonesDto } from './childlisttonesdto';
import { ListTonesDto, ListTonesDtoImpl } from './listtonesdto';
import { BaseContext } from '../../../utils/basecontext';
import { Strings } from '../../../utils/resources/strings';
import { DateTransform } from '../../../ui/toolkit/datetransform/datetransform';
//import * as React from 'react';
//import * as ReactDOMServer from 'react-dom/server';
//import * as ReactDOM from 'react-dom';

export class PlayingToMyListDetails {
    parseListTonesResponse(currentlyPlayingTones: ChildListTonesDto[], context: BaseContext): ListTonesDto[] {
        let listToneDtos: ListTonesDto[] = [];
        let listToneDto: ListTonesDtoImpl;

        currentlyPlayingTones.forEach((currentlyPlayingToneItem: ChildListTonesDto) => {
             console.log("Lion Tiger:",currentlyPlayingToneItem.getServiceName());
            listToneDto = new ListTonesDtoImpl();
            listToneDto.setId(currentlyPlayingToneItem.getId());
            listToneDto.setContentId(currentlyPlayingToneItem.getId());
            listToneDto.setToneName(currentlyPlayingToneItem.getToneName());
            listToneDto.setToneUrl(currentlyPlayingToneItem.getToneUrl());
            listToneDto.setImgPath(currentlyPlayingToneItem.getImgPath());
            listToneDto.setAlbumName(currentlyPlayingToneItem.getAlbumName());
            listToneDto.setArtistName(currentlyPlayingToneItem.getArtistName());
            listToneDto.setIsStatusRBT(currentlyPlayingToneItem.getIsStatusRBT());
            listToneDto.setPrice(currentlyPlayingToneItem.getPrice());
            listToneDto.setStatus(currentlyPlayingToneItem.getStatus());
            listToneDto.setExpirydate(currentlyPlayingToneItem.getExpirydate());
            listToneDto.setServiceName(currentlyPlayingToneItem.getServiceName());
            listToneDto.setIsShuffle(currentlyPlayingToneItem.getIsShuffle());
            if(currentlyPlayingToneItem.getGroupDto() !== undefined)
            {
                listToneDto.setGroupDto(currentlyPlayingToneItem.getGroupDto());
            }

            listToneDto.setCallerStatus(context.getResources().getString(Strings.shuffle));
            // if (currentlyPlayingToneItem.getIsShuffle() === context.getResources().getString(Strings.t)) {
            // }
            // else {
            //     listToneDto.setCallerStatus(context.getResources().getString(Strings.live));
            // }

            if(currentlyPlayingToneItem.getServiceName() === "AllCaller")
            {
                console.log("---------tigerall"+context.getResources().getString(Strings.all));
                listToneDto.setCaller(context.getResources().getString(Strings.all));
            }
            else if(currentlyPlayingToneItem.getServiceName() === "SpecialCallerSetting")
            {
                listToneDto.setCaller(currentlyPlayingToneItem.getMsisdnB());
            }
            else if(currentlyPlayingToneItem.getServiceName() === context.getResources().getString(Strings.groupCallerSetting))
            {
                listToneDto.setCaller(currentlyPlayingToneItem.getGroupDto().getGroupName());
            }

            if (!(currentlyPlayingToneItem.getCustomiseStartDate() === context.getResources().getString(Strings.zero)) 
            || !(currentlyPlayingToneItem.getCustomiseEndDate() === context.getResources().getString(Strings.zero)))
            {
                console.log("--tigercustome");
                listToneDto.setTime(context.getResources().getString(Strings.custom));
                /* listToneDto.setFrom(moment(currentlyPlayingToneItem.getCustomiseStartDate(), "yyyy-MM-DD").format("DD/MM/yyyy") + " " + 
                          moment(currentlyPlayingToneItem.getCustomiseStartTime(), "hh:mm:ss").format("HH:mm")); */
                listToneDto.setFrom(DateTransform.formatDateFormBackend(currentlyPlayingToneItem.getCustomiseStartDate()) + " " + 
                          DateTransform.formatTime(currentlyPlayingToneItem.getCustomiseStartTime()));

                /* listToneDto.setTo(moment(currentlyPlayingToneItem.getCustomiseEndDate(), "yyyy-MM-DD").format("DD/MM/yyyy") + " " + 
                          moment(currentlyPlayingToneItem.getCustomiseEndTime(), "hh:mm:ss").format("HH:mm")); */
                listToneDto.setTo(DateTransform.formatDateFormBackend(currentlyPlayingToneItem.getCustomiseEndDate()) + " " + 
                          DateTransform.formatTime(currentlyPlayingToneItem.getCustomiseEndTime()));
                listToneDto.setType(context.getResources().getString(Strings.NONE));
                listToneDto.setRepeats([context.getResources().getString(Strings.none)]);
                listToneDto.setTimeType(context.getResources().getString(Strings.CUSTOM_TIME));
            }
            else if (!(currentlyPlayingToneItem.getStartTimeWeekly() === context.getResources().getString(Strings.zero_time)) 
            && (!(currentlyPlayingToneItem.getEndTimeWeekly() === context.getResources().getString(Strings.time_24))))
            {
                console.log("--tigerweekly");
                
                    listToneDto.setFrom(DateTransform.formatTime(currentlyPlayingToneItem.getStartTimeWeekly()));
                    listToneDto.setTo(DateTransform.formatTime(currentlyPlayingToneItem.getEndTimeWeekly()));
                    listToneDto.setType(context.getResources().getString(Strings.WEEKLY));
                    listToneDto.setRepeats(this.daysOfWeek(currentlyPlayingToneItem.getWeeklyDays(), context));
                    listToneDto.setTimeType(context.getResources().getString(Strings.WEEKLY_TIME));
                    listToneDto.setTime(context.getResources().getString(Strings.custom));
            } 
            else if (!(currentlyPlayingToneItem.getStartDayMonthly() === context.getResources().getString(Strings.zero)) || !(currentlyPlayingToneItem.getEndDayMonthly() === context.getResources().getString(Strings.zero)))
            {
                console.log("--tigermonthly");
                let startDayMonthly = currentlyPlayingToneItem.getStartDayMonthly();
                let endDayMonthly = currentlyPlayingToneItem.getEndDayMonthly();
                listToneDto.setTimeType(context.getResources().getString(Strings.MONTHLY_TIME));
                listToneDto.setTime(context.getResources().getString(Strings.custom));
                 listToneDto.setFrom((startDayMonthly.startsWith(context.getResources().getString(Strings.zero)) ? startDayMonthly.slice(1,2) : startDayMonthly) + 
                 this.getMonthlyDayOrdinal(startDayMonthly, context)  + " " + 
                 DateTransform.formatTime(currentlyPlayingToneItem.getStartTimeMonthly())); 

                console.log("#####: "+listToneDto.getFrom());

                listToneDto.setTo((endDayMonthly.startsWith(context.getResources().getString(Strings.zero)) ? endDayMonthly.slice(1,2) : endDayMonthly)+ 
                           this.getMonthlyDayOrdinal(endDayMonthly, context) +" " + 
                           DateTransform.formatTime(currentlyPlayingToneItem.getStartTimeMonthly()));
                listToneDto.setType(context.getResources().getString(Strings.MONTHLY));
                listToneDto.setRepeats([context.getResources().getString(Strings.monthly)]);
            } 
            else if (!(currentlyPlayingToneItem.getYearlyStartMonth() === context.getResources().getString(Strings.zero)) || !(currentlyPlayingToneItem.getYearlyEndMonth() === context.getResources().getString(Strings.zero))) 
            {
                console.log("--tigeryearly");
                listToneDto.setTime(context.getResources().getString(Strings.custom)); 
                listToneDto.setTimeType(context.getResources().getString(Strings.YEARLY_TIME));
                listToneDto.setFrom(currentlyPlayingToneItem.getYearlyStartDay() + "/" + 
                                    currentlyPlayingToneItem.getYearlyStartMonth() + " " + 
                                    DateTransform.formatTime(currentlyPlayingToneItem.getYearlyStartTime()));

                listToneDto.setTo(currentlyPlayingToneItem.getYearlyEndDay() + "/" + 
                                  currentlyPlayingToneItem.getYearlyEndMonth() + " " + 
                                  DateTransform.formatTime(currentlyPlayingToneItem.getYearlyEndTime()));

                listToneDto.setType(context.getResources().getString(Strings.YEARLY));
                listToneDto.setRepeats([context.getResources().getString(Strings.yearly)]);
            }
            else {
                console.log("--tigernone");
                listToneDto.setTimeType(context.getResources().getString(Strings.WEEKLY_TIME));
                listToneDto.setTime(context.getResources().getString(Strings.full_day));
                listToneDto.setFrom(context.getResources().getString(Strings.default_start_time));
                listToneDto.setTo(context.getResources().getString(Strings.default_end_time));
                listToneDto.setType(context.getResources().getString(Strings.WEEKLY));
                listToneDto.setRepeats(this.daysOfWeek(currentlyPlayingToneItem.getWeeklyDays(), context));
            }
            listToneDtos.push(listToneDto);
        });
        return listToneDtos;
    }

    private daysOfWeek(weeklyDays: string, context: BaseContext): string[] {
        let activeDays: string[] = [];

        if (weeklyDays !== undefined) {
            let days: string[] = weeklyDays.split(",");

            days.forEach((dayItem: string) => {

                switch (dayItem) {
                    case "1":
                        {
                            activeDays.push(context.getResources().getString(Strings.sun));
                            break;
                        }
                    case "2":
                        {
                            activeDays.push(context.getResources().getString(Strings.mon));
                            break;
                        }
                    case "3":
                        {
                            activeDays.push(context.getResources().getString(Strings.tue));
                            break;
                        }
                    case "4":
                        {
                            activeDays.push(context.getResources().getString(Strings.wed));
                            break;
                        }
                    case "5":
                        {
                            activeDays.push(context.getResources().getString(Strings.thu));
                            break;
                        }
                    case "6":
                        {
                            activeDays.push(context.getResources().getString(Strings.fri));
                            break;
                        }
                    case "7":
                        {
                            activeDays.push(context.getResources().getString(Strings.sat));
                            break;
                        }
                    default:
                        {

                        }
                }
            });
        }

        console.log("-----activate Days: " + activeDays);
        return activeDays;
    }

    private getMonthlyDayOrdinal(monthlyDay: string , context: BaseContext): string
     {
        switch (monthlyDay)
        {
            case "01":
            case "21":
            case "31":
                {
                    return context.getResources().getString(Strings.st)+ " " +
                           context.getResources().getString(Strings.day);
                }
            case "02":
            case "22":
                {
                    return context.getResources().getString(Strings.nd)+ " " +
                           context.getResources().getString(Strings.day);
                }
            case "03":
            case "23":
                {
                   /*  var xmlString = "<div id='demo'><sup>rd</sup></div>";
                    //var doc = new DOMParser().parseFromString(xmlString, "text/html");
                    var rdString = "rd".sup() ;
                    var htmll = document.getElementById("demo") as HTMLElement;
                    htmll = rdString;
 */
                   /*  return (
                            <sup id="fool">rd</sup>
                        ); */
                    //return HTMLStyleElement   .fromHtml("rd"+"<sup>-2</sup>");
                      return context.getResources().getString(Strings.rd)+ " " +
                              context.getResources().getString(Strings.day); 
                              
                }
            default:
                {
                    /* return (
                    <div>
                        th
                    </div>); */

                    return context.getResources().getString(Strings.th)+ " " +
                          context.getResources().getString(Strings.day);
                }         
        }       
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/listtones/playingtomylistdetails.tsx